import { TextField, InputAdornment } from '@mui/material';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { parseISO, format } from 'date-fns';
import { de, enUS, tr } from 'date-fns/locale';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { AppState } from 'src/store/Store';

const Cm_DatePicker = ({ date, setDate, readOnly = false, label, disableFuture = false, required = false, hideIcon = false, styling = {} }: any) => {
  // Translations
  const language_redux = useSelector((state: AppState) => state.customizer.isLanguage);
  const [language, setLanguage] = useState(language_redux);

  useEffect(() => {
    setLanguage(language_redux);
  });

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={language === 'tr' ? tr : enUS}>
      <DatePicker //
        key={date}
        value={date ? parseISO(date) : null}
        onChange={(newValue: Date | null | any) => setDate(format(newValue, 'yyyy-MM-dd'))}
        readOnly={readOnly}
        disableFuture={disableFuture}
        label={label ? (required ? label + ' *' : label) : null}
        slots={{
          textField: TextField,
        }}
        slotProps={{
          textField: {
            sx: {
              '& .MuiInputBase-input': { paddingRight: 0 },
              width: '100%',
              fontSize: '10px',
              ...(styling || {}),
            }
          }
        }}
      />
    </LocalizationProvider>
  );
};

export default Cm_DatePicker;
